export default (arr = []) => arr
  .filter((value, index, self) => self.indexOf(value) === index);
